"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_intl_1 = require("react-intl");
const react_hook_form_1 = require("react-hook-form");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const tables_1 = require("../../../../tables");
const BoxContent = () => {
    const lootBox = (0, react_hook_form_1.useWatch)({ name: "lootBox" });
    if (!lootBox?.content?.components?.length) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { mt: 1 }, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Typography, { variant: "h6", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "pages.loot.boxContent.title" }) }), (0, jsx_runtime_1.jsx)(tables_1.LootBoxContent, { lootBox: lootBox })] }));
};
exports.BoxContent = BoxContent;
//# sourceMappingURL=index.js.map